import { PcbNodeTypes } from "@buildwithflux/models";
import { getAncestorUidByType, removeChildUidsFromNode, removePcbNodesFromMap } from "../nodes";
/** Delete document nets and pcb net nodes for given nets. WARNING: leaves descendants (eg traces)
 * as orphans! The caller must ensure to reparent those orphans. Not to be used in isolation; this
 * is only a helper for PcbTreeManager.updateNetNodes() which ensures any children are reparented.
 *
 * TODO: that's a fragile design and we should refactor it to be more atomic. (Perhaps instead, this
 * function could remove and return any orphans, leaving the document in a consistent state but
 * allowing the caller to handle the orphans as needed.)
 * Note from @bryhoyt 18 Dec 2024: I'm *fairly* sure now we can eliminate this. Need to test and
 * think more about it. See comment at main callsite in updateNetNodes().
 */
export function deleteNetsExcludingDescendants(document, netIds, pcbNodes) {
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    netIds.forEach((deletedNetId) => {
        // We skip deleting Nets/Traces that are under a sub-layout (i.e. elment).
        // NOTE: the getAncestorUidByType() call will error if the node does not exist
        // so we need to check if the node exists first. If it does not exist we still
        // want to delete the document net.
        // TODO we should not even be attempting to pass sub-layout nets to this function!
        // If that's a problem for the caller, then the caller is using a bad definition of "net"
        // in this context, and probably has other problems. The only reason we're calling this
        // function is to operate specifically on host nets.
        if (pcbNodes[deletedNetId] && getAncestorUidByType(pcbNodes, deletedNetId, PcbNodeTypes.element)) {
            return;
        }
        delete document.nets[deletedNetId];
        removeNodesExcludingDescendants(pcbNodes, [deletedNetId]);
    });
}
/**
 * Remove given nodes from pcb tree, leaving any descendants as orphans. The caller must
 * ensure any orphans are reparented. This is only a helper for PcbTreeManager.updateNetNodes();
 * not to be used in isolation!
 */
const removeNodesExcludingDescendants = (pcbNodes, nodeUids) => {
    // Remove childUids from parent first
    let errorSeen = false;
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    nodeUids.forEach((nodeUid) => {
        const nodeToRemove = pcbNodes[nodeUid];
        if (!nodeToRemove) {
            if (errorSeen === false) {
                /* eslint-disable no-console */
                // Use warn instead of error since this can happen during race conditions
                // and the code handles it gracefully by continuing
                console.warn("Trying to remove a non-existent node", nodeUid);
                errorSeen = true;
            }
            return;
        }
        removeChildUidsFromNode(pcbNodes, nodeToRemove.parentUid, [nodeToRemove.uid]);
    });
    // Remove the node
    removePcbNodesFromMap(pcbNodes, nodeUids);
    return nodeUids;
};
//# sourceMappingURL=deleteNets.js.map